import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['Units', 'UnitTypes'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      unitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataType:
        build.mutation<
          UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiResponse,
          UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiArg
        >({
          query: (queryArg) => ({
            url: `/Units/${queryArg.unitId}/AlarmConfiguration/${queryArg.key}/${queryArg.unitTypeInputId}/${queryArg.dataType}`,
            method: 'PUT',
            params: {
              value: queryArg.value,
            },
          }),
          invalidatesTags: ['Units'],
        }),
      unitTypesGetCollectionAsyncByqueryOptions: build.query<
        UnitTypesGetCollectionAsyncByqueryOptionsApiResponse,
        UnitTypesGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/UnitTypes`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['UnitTypes'],
      }),
      unitTypesGetAsyncByid: build.query<
        UnitTypesGetAsyncByidApiResponse,
        UnitTypesGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/UnitTypes/${queryArg.id}` }),
        providesTags: ['UnitTypes'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiResponse =
  /** status 204 No content */ object;
export type UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiArg =
  {
    /** The id of the Unit */
    unitId: number;
    /** The unitTypeInputIdt */
    unitTypeInputId: number;
    /** Configuration key */
    key: string;
    /** Configuration value */
    value?: string;
    /** Configuration dataType (optional) */
    dataType: string;
  };
export type UnitTypesGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 UnitType entities response */ ReadUnitTypeDto[];
export type UnitTypesGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>UnitTypeId</strong> (default), <strong>Name</strong>, <strong>Description</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>UnitTypeId</strong> (default), <strong>Name</strong>, <strong>Description</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type UnitTypesGetAsyncByidApiResponse =
  /** status 200 UnitType entities response */ ReadUnitTypeDto;
export type UnitTypesGetAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type ErrorResult4 = ErrorResult;
export type ReadSensorRequirement = {
  SensorRequirementId: number;
  IsRequired: boolean;
  DataType?: string;
};
export type ReadAlarmTypeConfigurationSpecDto = {
  Key?: string;
  Type: 'Integer' | 'Datetime';
  AlarmTypeId: number;
};
export type ReadUnitTypeInputDto = {
  UnitTypeInputId: number;
  Description?: string;
  Name: string;
  SensorRequirements?: ReadSensorRequirement[];
  AlarmTypeConfigurations?: ReadAlarmTypeConfigurationSpecDto[];
};
export type ReadUnitTypeDto = {
  UnitTypeId: number;
  Name: string;
  Description?: string;
  UnitTypeInputs?: ReadUnitTypeInputDto[];
};
export const {
  useUnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeMutation,
  useUnitTypesGetCollectionAsyncByqueryOptionsQuery,
  useLazyUnitTypesGetCollectionAsyncByqueryOptionsQuery,
  useUnitTypesGetAsyncByidQuery,
  useLazyUnitTypesGetAsyncByidQuery,
} = injectedRtkApi;
